module.exports = __webpack_public_path__ + "static/media/ic_trash_red.7e43fc10.svg";